import React from 'react';
import {getDate, useStyles} from './helper';
import clsx from 'clsx';

const EventItem = ({item, login}) => {
    const {date_event, game_name, amount_win, amount_bet, balance_after, balance_before} = item;
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <span className={classes.date}>{getDate(date_event)}</span>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: 10}}>
                <span className={classes.helper} style={{marginRight: 12}}>Игра:</span>
                <span className={clsx(classes.description, classes.capitalize)}>
                    {game_name}
                </span>
            </div>
            <div className={classes.wrap}>
                <div className={classes.w50}>
                    <div className={classes.wrapBlock}>
                        <span  className={classes.helper}>Сумма ставки:</span>
                        <span className={classes.description}>
                            {new Intl.NumberFormat('ru-RU').format(amount_bet)} 
                        </span>
                    </div>
                    <div className={classes.wrapBlock}>
                        <span  className={classes.helper}>Баланс до:</span>
                        <span className={classes.description}>
                            {new Intl.NumberFormat('ru-RU').format(balance_before ? balance_before.toFixed(2) : balance_before)} 
                        </span>
                    </div>
                </div>
                <div className={classes.w50}>
                    <div className={classes.wrapBlock}>
                        <span className={classes.helper}>Выигрыш:</span>
                        <span className={classes.description}>
                            {new Intl.NumberFormat('ru-RU').format(amount_win)} 
                        </span>
                    </div>
                    <div className={classes.wrapBlock}>
                        <span  className={classes.helper}>Баланс после:</span>
                        <span className={classes.description}>
                            {new Intl.NumberFormat('ru-RU').format(balance_after ? balance_after.toFixed(2) : balance_after)} 
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EventItem;